import { ExternalLinkIcon } from "@cashrent/commonground-elements";
import { Divider, Popover } from "antd";
import { relativeDate } from "../../../../utils/format";
import React from "react";
import "./notifications.scss";
import { getLinkToCG } from "../../../../utils/router";


const ItemNotification = ({ item }) => {
  const data = JSON.parse(item.data);
  return (
    <div style={{ display: "flex", paddingRight: "12px", paddingBlock: "15px" }}>
      <span style={{ paddingInline: "10px" }}>
        {/* <Avatar size={40}>{data.shortName}</Avatar> */}
      </span>
      <div style={{ display: "flex", width: "300px", flexDirection: "column" }}>
        <a href={getLinkToCG("/app/my-account/settings/notifications")}>
          <div
            style={{ fontSize: "15px", fontWeight: 400, color: "black" }}
            dangerouslySetInnerHTML={{ __html: data.data }}
          />
        </a>
        <span style={{ fontSize: "15px", fontWeight: 400, color: "rgb(146, 146, 146)" }}>
          {relativeDate(item.created_at)}
        </span>
      </div>
    </div>
  );
};

const NotificationsHeader = () => (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "25px 20px 15px", minWidth: "350px", alignItems: "center" }}>
      <div>
        <span style={{ fontSize: "20px", fontWeight: "600" }}>Notifications</span>
      </div>

      <a href={getLinkToCG("/app/my-account/settings/notifications")}>
        <div style={{ display: "flex", cursor: "pointer", alignItems: "center" }}>
          <p style={{ fontSize: "15px", fontWeight: 600, marginRight: "0.75rem", color: "black" }}> View all</p>
          <span style={{ marginTop: "2px" }}>
            <ExternalLinkIcon />
          </span>
        </div>
      </a>
    </div>
  );

const NotificationList = ({ data }) => (
    <div className="notifications">
      <NotificationsHeader />
      <Divider className="custom-divider" />
      {data.map((item, index) => (
        <>
          <div
            key={index}
            className={` ${
              index < data.length - 1
                ? "item-notification"
                : "item-notification-latest"
            } `}
          >
            <ItemNotification item={item} />
            {index < data.length - 1 && <Divider className="custom-divider" />}
          </div>
        </>
      ))}
    </div>
  );

const NotificationsPanel = ({ children, data }) => (
    <div className="notifications">
      <Popover
        content={<NotificationList data={data.data.slice(0, 5)} />}
        trigger="hover"
        placement="bottomRight"
      >
        {children}
      </Popover>
    </div>
  );

export default NotificationsPanel;
